import { prettifyProduct } from "utils/pretty.utils";
import { formatAmount, formatNumber } from "utils";
import moment from "moment";
import { DateTime } from "enums";

export const mapDataToList = ({ pointsHistory }) => {
  const {
    pointsHistoryId,
    cardNumber,
    points,
    transactionId,
    amount,
    productCode,
    mobileNumber,
    createdAt,
  } = pointsHistory;

  return {
    vipTransactionId: <div className="min-60 nowrap">{pointsHistoryId}</div>,
    vipCardNumber: <div>{cardNumber || "-"}</div>,
    mobileWithHash: <div>{mobileNumber || "-"}</div>,
    transactionAmount: <div>{formatAmount(amount ?? 0)}</div>,
    productTypeCapitalize: <div>{prettifyProduct(productCode)}</div>,
    pointsEarned: <div className="min-50 nowrap">{formatNumber(points, 2)} pts</div>,
    orNumber: <div>{transactionId}</div>,
    dateOfTransaction: <div className="min-60 nowrap">{moment(createdAt).format(DateTime.L)}</div>,
  };
};

export const mapFilterToRequest = (filterState) => {
  const { productCodes, ...fs } = filterState;
  return {
    ...fs,
    productCodes: productCodes.length > 0 ? productCodes.join(",") : null,
  };
};
